<div id="contact" class="contact-area ptb-100 bg-F7F5F4">
    <div class="container">
        <div class="section-title">
            <h3>{{ 'CONTACT-SECTION.contact-section-heading-h4' | translate }}</h3>
            <h2 [innerHTML]="'CONTACT-SECTION.contact-section-heading-h1' | translate"></h2>
            <p>{{ 'CONTACT-SECTION.contact-section-p-tag' | translate }}</p>
        </div>
        <div class="row">
            <div class="col-lg-7 col-md-12">
                <div class="contact-form">
                    <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                        <div class="row">
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label for="name">{{ 'CONTACT-SECTION.contact-section-form-field1' | translate }}</label>
                                    <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name">
                                    <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                        <div *ngIf="name.errors.required">Name is required.</div>
                                        <div *ngIf="name.errors.minlength">Name is minimum {{ name.errors.minlength.requiredLength }} character.</div>
                                        <div *ngIf="name.errors.maxlength">Name is maximum 50 character.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label for="email">{{ 'CONTACT-SECTION.contact-section-form-field2' | translate }}</label>
                                    <input required ngModel name="email" type="text" #email="ngModel" class="form-control" id="email">
                                    <div class="alert alert-danger" *ngIf="email.touched && !email.valid">Email Address is required.</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label for="subject">Subject</label>
                                    <input required ngModel name="subject" type="text" #subject="ngModel" class="form-control" id="subject">
                                    <div class="alert alert-danger" *ngIf="subject.touched && !subject.valid">Subject is required.</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                    <label for="number">{{ 'CONTACT-SECTION.contact-section-form-field3' | translate }}</label>
                                    <input required ngModel name="number" type="text" #number="ngModel" class="form-control" id="number">
                                    <div class="alert alert-danger" *ngIf="number.touched && !number.valid">Phone number is required.</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <label for="message">{{ 'CONTACT-SECTION.contact-section-form-field4' | translate }}</label>
                                    <textarea required ngModel #message="ngModel" name="message" id="message" cols="30" rows="4" class="form-control"></textarea>
                                    <div class="alert alert-danger" *ngIf="message.touched && !name.valid">Message is required.</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="btn btn-primary"  [class.disabled]="!contactForm.valid">
                                    {{ 'CONTACT-SECTION.contact-section-form-button' | translate }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-lg-5 col-md-12">
                <div class="contact-info">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <ul>
                                <li><i class="fas fa-map-marker-alt"></i> <span>{{ 'CONTACT-SECTION.contact-section-icon-one' | translate }}:</span>{{ 'CONTACT-SECTION.contact-section-icon-one-text' | translate }}</li>
                                <li><i class="far fa-envelope"></i> <a href="mailto:info@maksellent.com"><span>{{ 'CONTACT-SECTION.contact-section-icon-two' | translate }}:</span>{{ 'CONTACT-SECTION.contact-section-icon-two-text' | translate }}</a></li>
                                <li><i class="fas fa-phone-alt"></i> <a href="tel:+902164551221"><span>{{ 'CONTACT-SECTION.contact-section-icon-three' | translate }}:</span>{{ 'CONTACT-SECTION.contact-section-icon-three-text' | translate }}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
